export default __webpack_public_path__ + "static/media/exam_edition_2.0b81956b.jpg";